/* eslint-disable */
const auth = {  
    namespaced:true,    

    state: {
        isLoggedIn: !!localStorage.getItem('token'),
        user:[]
    },

    getters: {},

    actions: {
        GET_USER: async ({commit}) => {
            let token = localStorage.getItem('token')
            if(token != null){
                let { data } = await axios.get(`api/userInfo`)
                commit('SET_USER', data)
            } 
        },
    },

    mutations: {
        SET_USER: (state, payload) => {
            state.user = payload
        },

        LOGIN_USER(state){
            state.isLoggedIn = true
        },
        LOGOUT_USER(state){
            state.isLoggedIn = false
        }
    }
}

export default auth


// WEBPACK FOOTER //
// ./src/modules/authentication.js